<script lang="ts">
  import data from '$lib/data/sales_data.json';
  import { scaleBand, scaleLinear } from 'd3-scale';
  import { max } from 'd3-array';
  import AxisBottom from './AxisBandBottom.svelte';
  import AxisLeft from './AxisLeft.svelte';
  import AxisRight from './AxisRight.svelte';

  let xScale, yScale1, yScale2;

  let width = 400; // width will be set by the clientWidth
  const height = 350;
  const margin = { top: 40, right: 30, bottom: 20, left: 50 };

  $: if (data && width) {
    xScale = scaleBand()
      .domain(data.map((d) => d.month))
      .range([margin.left, width - margin.right])
      .padding(0.1);

    yScale1 = scaleLinear()
      .domain([0, max(data, (d) => d.sales)])
      .range([height - margin.bottom, margin.top]);

    yScale2 = scaleLinear()
      .domain([0, max(data, (d) => d.profit)])
      .range([height - margin.bottom, margin.top]);
  }
</script>

<div class="wrapper" bind:clientWidth={width}>
  {#if data && width}
    <svg
      width={width + margin.left + margin.right}
      height={height + margin.top + margin.bottom}>
      <AxisBottom
        {width}
        {height}
        {margin}
        {xScale}
        formatFunc={(d) => d.slice(0, 3)}
        filterFunc={(d, i) => i % 3 === 0} />
      <AxisLeft {width} {height} {margin} yScale={yScale1} ticksNumber={5} />
      <AxisRight {width} {height} {margin} yScale={yScale2} />
    </svg>
  {/if}
</div>
